module.exports = "/_next/static/files/0e9344eaa120e6831d97e37e9f6b4754.jpg";